import { Card, Col, Row } from "reactstrap";
import { PeopleKnow, ViewProfile } from "../../../../../constants";
import ActivityLog from "./ActivityLog";
import EducationAndEmployment from "./EducationAndEmployment";
import HobbiesAndInterests from "./HobbiesAndInterests";
import PeopleYouMayKnow from "./PeopleYouMayKnow";
import MutualFriends from "../../common/MutualFriends";
import ActivityFeedClass from "../../common/ActivityFeed";
import { dynamicImage } from "../../../../../utils";
import MyProfile from "../../common/myProfile";
import ProfileInfoCard from "../../common/rightBar/ProfileInfoCard";
import FollowerCard from "../../common/rightBar/FollowerCard";
import FollowingsCard from "../../common/rightBar/FollowingsCard";
import LatestPhotos from "../../common/rightBar/LatestPhotos";
import FriendsCard from "../../common/rightBar/FriendsCard";
import { Image } from "../../../../../coreComponents/Image";

const About = () => {
  return (
    <Row>
      <Col xl="3" lg="12" md="5" className="xl-40 box-col-4e">
        <div className="default-according style-1 faq-accordion job-accordion">
          <MyProfile />
          <MutualFriends />
          <ActivityFeedClass />
        </div>
      </Col>
      <Col xl="6" className="xl-60 box-col-8" lg="12" md="7">
        <Row>
          <PeopleYouMayKnow heading={PeopleKnow} />
          <HobbiesAndInterests />
          <EducationAndEmployment />
          <PeopleYouMayKnow heading={ViewProfile} />
          <ActivityLog />
        </Row>
      </Col>
      <Col xl="3" className="xl-100 box-col-12">
        <div className="default-according style-1 faq-accordion job-accordion">
          <Row>
            <Row>
              <Col xl="12" className="xl-50 box-col-6">
                <ProfileInfoCard />
              </Col>
              <Col xl="12" className="xl-50 box-col-6">
                <FollowerCard />
              </Col>
              <Col xl="12" className="xl-50 box-col-6">
                <FollowingsCard />
              </Col>
              <Col xl="12" className="xl-50 box-col-6">
                <LatestPhotos />
              </Col>
              <Col xl="12" className="xl-50 box-col-6">
                <FriendsCard />
              </Col>
              <Col xl="12" className="xl-50 box-col-6">
                <Card>
                  <Image className="img-fluid rounded-3 w-100" src={dynamicImage(`social-app/timeline-4.png`)} alt="timeline" />
                </Card>
              </Col>
            </Row>
          </Row>
        </div>
      </Col>
    </Row>
  );
};
export default About;
